import { defineManifest } from "@tc/sdk";
export const manifest = defineManifest({
    id: "insights",
    name: "Insights",
    version: "0.1.0",
    tier: "addon",
    accent: "brand",
    description: "Each morning the biggest movements in your figures become short stat cards: a site's shop sales up 14% on last week, a department slipping, a site well behind its peers. Every number is worked out from your data; thumbs up or down teaches it what you want more of. Alerts tell you when a figure crosses a line or something happens, in the app and by push.",
    permissions: {
        view: "See the insights for your sites, and switch on alerts",
        manage: "When they run, what counts as worth a card, running them now, and who may make their own alerts",
    },
    grants: { "Head office": ["view", "manage"], "Area manager": ["view"], "Site manager": ["view"] },
    widgets: [
        { key: "today", title: "Insights", description: "This morning's biggest movements in your figures, as short cards.", group: "Sales", size: 2, permission: "view", defaultOn: true, order: 15 },
    ],
    nav: [
        { label: "Insights", path: "/insights", section: "dashboard", tab: "Insights", tabIcon: "sparkle", permission: "view", icon: "sparkle", order: 5, blurb: "The biggest moves in your figures, as short cards each morning" },
        { label: "Alerts", path: "/insights/alerts", section: "dashboard", tabIcon: "sparkle", tab: "Insights", permission: "view", icon: "bell", order: 5.5, blurb: "Tell me when: your sites' figures, or something that happens" },
        { label: "Insights settings", path: "/insights/settings", section: "dashboard", kind: "settings", permission: "manage", icon: "settings", order: 6, blurb: "When insights run and what counts as worth a card" },
    ],
});
